import styled from 'styled-components';
import UIFullScreen from 'UIComponents/dialog/UIFullScreen';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIOverlay from 'UIComponents/overlay/UIOverlay';
import OutsideClickListener from '../OutsideClickListener';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledOverlay = styled(UIOverlay).withConfig({
  displayName: "EPFullscreenOverlay__StyledOverlay",
  componentId: "sc-1wufbr4-0"
})(["background-color:rgb(45 62 80 / 25%) !important;"]);
const EPFullscreenOverlay = ({
  children,
  onClose
}) => {
  return /*#__PURE__*/_jsx(UIFullScreen, {
    children: /*#__PURE__*/_jsx(StyledOverlay, {
      width: 100,
      children: /*#__PURE__*/_jsx(UIFlex, {
        style: {
          position: 'absolute',
          top: 100,
          bottom: 0,
          left: 0,
          right: 0
        },
        justify: "center",
        children: /*#__PURE__*/_jsx(OutsideClickListener, {
          onOutsideClick: onClose,
          children: children
        })
      })
    })
  });
};
export default EPFullscreenOverlay;